

































































import { computed, defineComponent, unref, watch } from '@nuxtjs/composition-api';
import SizeGuide from '@shared/components/PDP/SizeGuide/SizeGuide.vue';
import useProductValidation from '@shared/composables/useProductValidation';
import useProductVariants from '@shared/composables/useProductVariants';

export default defineComponent({
  name: 'ProductVariants',
  components: { SizeGuide },
  props: {
    product: {
      type: Object,
      default: null,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableValidation: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup({ product, disableValidation }, { emit }) {
    const productId = computed(() => unref(product.id));

    const { set: setValidation, get: getValidation, showErrors } = useProductValidation();
    const { options, updateSelectedOptions, selectedOptions } = useProductVariants(
      computed(() => unref(product?.options)),
      computed(() => unref(product?.variants)),
    );

    const onOptionChecked = (name: string, value: string) => {
      updateSelectedOptions({ name, value });

      if (options.value.length === selectedOptions.value.length) {
        emit('on-change', selectedOptions.value, productId.value);
      }
    };

    const isOptionChecked = (optionName: string, optionValue: string) => {
      return selectedOptions.value.find(({ name }) => name === optionName)?.value === optionValue;
    };

    const selectedOptionName = (optionName: string): string | undefined =>
      selectedOptions.value.find((x) => x.name === optionName)?.value;

    const vendor = computed(() => unref(product.vendor));
    const collections = computed(() => unref(product.collections));

    watch(
      [options, selectedOptions],
      (newVal, prevVal) => {
        if (options?.value.length && newVal !== prevVal && !disableValidation) {
          setValidation(
            productId.value,
            options.value
              .filter(({ name }) => !selectedOptions.value.find((s) => s.name === name))
              .map(({ name }) => name),
          );
        }
      },
      { immediate: true },
    );

    const validationErrors = computed(() =>
      !disableValidation ? getValidation(productId.value) : [],
    );

    const hasErrors = computed(() => showErrors.value && !!validationErrors.value.length);

    return {
      options,
      selectedOptionName,
      onOptionChecked,
      isOptionChecked,
      vendor,
      collections,
      productId,
      hasErrors,
      validationErrors,
    };
  },
});
